import { DataType, ReadWrite, RegisterTable } from '../lib/inverter.model';
import { create_auto_test_result_v, create_auto_test_result_hz, V3AutoTestConfig } from './inverter.config';

export enum AutoTestState {
  Success = 0x0000,
  StandardRunning = 0x0001,
  QuickRunning = 0x0002,
  Refused = 0xFFFB,
  NoResponse = 0xFFFC,
  Forbidden = 0xFFFD,
  StorageFailed = 0xFFFE,
  Incorrect = 0xFFFF,
}

export const AutoTestStateStyles: { [key: string]: any } = {
  [AutoTestState.Success]: { '--background': 'var(--green-100)' },
  [AutoTestState.StandardRunning]: { '--background': 'var(--yellow-100)' },
  [AutoTestState.QuickRunning]: { '--background': 'var(--yellow-100)' },
  [AutoTestState.Refused]: { '--background': 'var(--red-100)' },
  [AutoTestState.NoResponse]: { '--background': 'var(--red-100)' },
  [AutoTestState.Forbidden]: { '--background': 'var(--red-100)' },
  [AutoTestState.StorageFailed]: { '--background': 'var(--red-100)' },
  [AutoTestState.Incorrect]: { '--background': 'var(--red-100)' },
};

export const AutoTestKeys: { [key: string]: string } = {
  [AutoTestState.Success]: 'i18n.AutoTestPage.resolveSuccess',
  [AutoTestState.StandardRunning]: 'i18n.AutoTestPage.StandardRunning',
  [AutoTestState.QuickRunning]: 'i18n.AutoTestPage.QuickRunning',
  [AutoTestState.Refused]: 'i18n.AutoTestPage.Refused',
  [AutoTestState.NoResponse]: 'i18n.AutoTestPage.NoResponse',
  [AutoTestState.Forbidden]: 'i18n.AutoTestPage.Forbidden',
  [AutoTestState.StorageFailed]: 'i18n.AutoTestPage.StorageFailed',
  [AutoTestState.Incorrect]: 'i18n.AutoTestPage.Incorrect',
};

export const V3DeviceAutoTest: Partial<RegisterTable> = {
  AutoTest_control: {
    address: 0x102e,
    name: 'AutoTest_Control',
    dataType: DataType.U16,
    description: `
    Italy automatic test
    Write: Operate standard test;
    0x0002: Operate quick test;
      When reading, return the status of the last write operation:
    0x0000: success
    0x0001: Standard test is being operated
    0x0002: Quick test is being operated
    0xFFFB: The operation failed and the controller refused to respond (maybe the controller is busy or the configuration is wrong)
    0xFFFC: The operation failed and the controller did not respond
    0xFFFD: Operation failed, current function is forbidden
    0xFFFE: Operation failed, parameter storage failed
    0xFFFF: The operation failed, and the input parameters are incorrect `,
    access: ReadWrite.ReadWrite,
    quantity: 1,
  },
  RatedVoltage: {
    address: 0x0841,
    name: 'RatedVoltage',
    dataType: DataType.U16,
    description: 'Grid Rated voltage',
    access: ReadWrite.ReadWrite,
    quantity: 1,
    accuracy: 0.1,
  },
  RatedFrequency: {
    address: 0x0881,
    name: 'RatedFrequency',
    dataType: DataType.U16,
    description: 'Grid Rated Frequency',
    access: ReadWrite.ReadWrite,
    quantity: 1,
    accuracy: 0.01,
  },
};

const AutoTest_Config_Start_v = V3AutoTestConfig.AutoTest_results_v.start;
for (let i = 0; i < V3AutoTestConfig.AutoTest_results_v.length; i++) {
  const { auto_test_result_v, auto_test_result_ms, auto_test_result_v_default, auto_test_result_ms_default } = create_auto_test_result_v(
    i + 1,
    AutoTest_Config_Start_v + i * 4,
  );
  V3DeviceAutoTest[`AUTO_TEST_RESULT_V_${i + 1}`] = auto_test_result_v;
  V3DeviceAutoTest[`AUTO_TEST_RESULT_V_MS_${i + 1}`] = auto_test_result_ms;
  V3DeviceAutoTest[`AUTO_TEST_RESULT_V_DEFAULT_${i + 1}`] = auto_test_result_v_default;
  V3DeviceAutoTest[`AUTO_TEST_RESULT_V_MS_DEFAULT_${i + 1}`] = auto_test_result_ms_default;
}

const AutoTest_Config_Start_hz = V3AutoTestConfig.AutoTest_results_hz.start;
for (let i = 0; i < V3AutoTestConfig.AutoTest_results_hz.length; i++) {
  const { auto_test_result_hz, auto_test_result_ms, auto_test_result_hz_default, auto_test_result_ms_default } = create_auto_test_result_hz(
    i + 1,
    AutoTest_Config_Start_hz + i * 4,
  );
  V3DeviceAutoTest[`AUTO_TEST_RESULT_HZ_${i + 1}`] = auto_test_result_hz;
  V3DeviceAutoTest[`AUTO_TEST_RESULT_HZ_MS_${i + 1}`] = auto_test_result_ms;
  V3DeviceAutoTest[`AUTO_TEST_RESULT_HZ_DEFAULT_${i + 1}`] = auto_test_result_hz_default;
  V3DeviceAutoTest[`AUTO_TEST_RESULT_HZ_MS_DEFAULT_${i + 1}`] = auto_test_result_ms_default;
}

for (let i = 0; i <= V3AutoTestConfig.AutoTest_results_hz.length; i++) {
  const { auto_test_result_hz, auto_test_result_ms, auto_test_result_hz_default, auto_test_result_ms_default } = create_auto_test_result_hz(
    i + 1,
    AutoTest_Config_Start_hz + i * 4,
  );
  V3DeviceAutoTest[`AUTO_TEST_RESULT_HZ_${i + 1}`] = auto_test_result_hz;
  V3DeviceAutoTest[`AUTO_TEST_RESULT_HZ_MS_${i + 1}`] = auto_test_result_ms;
  V3DeviceAutoTest[`AUTO_TEST_RESULT_HZ_DEFAULT_${i + 1}`] = auto_test_result_hz_default;
  V3DeviceAutoTest[`AUTO_TEST_RESULT_HZ_MS_DEFAULT_${i + 1}`] = auto_test_result_ms_default;
}

const auto_test_unk_start = 0x1324;
for (let index = 0; index < 0x10; index++) {
  V3DeviceAutoTest[`AUTO_TEST_RESULT_UNK_${index}`] = {
    address: auto_test_unk_start + index,
    name: `AUTO_TEST_RESULT_UNK_${index}`,
    dataType: DataType.U16,
    description: `Unknown result ${index}`,
    access: ReadWrite.Read,
    quantity: 1,
  };
}
